import * as React from 'react';
import * as yup from 'yup';
import enUs from '../../../../lang/en-us';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
import {
    accountNumberRegex,
    MaxAccountNumberLength,
    numberRegex,
    OTM_MAX_DATE,
} from '../../../../utils/constants';
import { ifscRegex } from '../../makeNct/CorrectionFolios/types';
import { InitStateType, OtmSchemaFields, RTA_CODES } from './types';
import { AccountTypes, IsAllow } from '../../../../redux-store/types/portfolio';
import { addDays } from 'date-fns';

const { dbCommercial, common } = enUs;

export const getBanks = () => {
    const {
        portfolios: { data: portfolioData },
    } = useSelector(({ portfolio }: RootStateType) => ({
        ...portfolio,
    }));
    const bankData: any = [];
    portfolioData?.forEach((portfolio: any) => {
        portfolio.schemes?.forEach((scheme: any) => {
            if (bankData.every((data: any) => data.bank?.name !== scheme.bank?.name)) {
                bankData.push({ bank: scheme.bank, rta: scheme?.rtaName });
            }
        });
    });
    return bankData;
};

export const eMandateSchema: OtmSchemaFields = yup.object({
    name: yup.string().required(dbCommercial.exploreMfs.eMandate.form.required.investorName),

    email: yup
        .string()
        .required(dbCommercial.exploreMfs.eMandate.form.required.email)
        .email(dbCommercial.exploreMfs.eMandate.form.invalid.email),

    mobile: yup
        .string()
        .test('is-mobile', dbCommercial.exploreMfs.eMandate.form.invalid.mobile, (value) =>
            numberRegex.test(value?.slice(1, value.length) || ''),
        )
        .min(10, dbCommercial.exploreMfs.eMandate.form.lengths.mobile)
        .required(dbCommercial.exploreMfs.eMandate.form.required.mobile),

    ifsc: yup
        .string()
        .required(dbCommercial.exploreMfs.eMandate.form.required.ifsc)
        .matches(ifscRegex, dbCommercial.exploreMfs.eMandate.form.invalid.ifsc),
    branch: yup.string().required(dbCommercial.exploreMfs.eMandate.form.required.branch),
    accountHolder: yup
        .string()
        .required(dbCommercial.exploreMfs.eMandate.form.required.accountHolder),
    accountNo: yup
        .string()
        .max(MaxAccountNumberLength, common.errors.bankErrors.accountNo.regexError)
        .required(dbCommercial.exploreMfs.eMandate.form.required.accountNo)
        .matches(accountNumberRegex, common.errors.bankErrors.accountNo.regexError),
    amount: yup
        .string()
        .required(dbCommercial.exploreMfs.eMandate.form.required.amount)
        .test('max-amount', dbCommercial.exploreMfs.eMandate.form.invalid.amount, (value) => {
            return Number(value) <= BANK_MAX_AMOUNT;
        }),
    confirmAccountNumber: yup
        .string()
        .oneOf(
            [yup.ref('accountNo')],
            dbCommercial.exploreMfs.eMandate.form.required.confirmAccountNoValidationMsg,
        )
        .required(dbCommercial.exploreMfs.eMandate.form.required.accountNo),
    fromDate: yup.date().required(dbCommercial.exploreMfs.eMandate.form.required.fromDate),
    toDate: yup.date().required(dbCommercial.exploreMfs.eMandate.form.required.toDate),
    bankName: yup.object().shape({
        bankName: yup.string().required(dbCommercial.exploreMfs.eMandate.form.required.bankName),
        ifscPrefixCode: yup
            .string()
            .required(dbCommercial.exploreMfs.eMandate.form.required.bankName),
    }),
    // declaration: yup.bool().oneOf([true], dbCommercial.errors.termsAndCondition),
    // untilCancelled:yup.string().oneOf([IsAllow.YES],dbCommercial.exploreMfs.eMandate.form.required.toDate)
});

export const VALIDATED_IFSC = 'VALIDATED_IFSC';
export const VALIDATED_IFSC_SHOW_POPUP = 'VALIDATED_IFSC_SHOW_POPUP';
export const VALIDATION_IFSC_FAILED = 'VALIDATION_IFSC_FAILED';
export const VALIDATION_IFSC_PENDING = 'VALIDATION_IFSC_PENDING';

export const otmFrequency = { label: 'As and when presented', value: 'ADHO' };
export const accountTypes = { label: 'SAVINGS', value: AccountTypes.SAVINGS };

export const rtaCodes = [
    {
        label: 'CAMS Serviced Fund eMandate',
        value: RTA_CODES.CAMS,
    },
    {
        label: 'KFIN Serviced Fund eMandate',
        value: RTA_CODES.KFIN,
    },
];

export const BANK_MAX_AMOUNT = 10000000;
export const MIN_EMANDATE_MONTHS = 6;
export const IFSC_LENGTH = 11;

export const eMandateStartDateDisable = (date: Date) => {
    const startDate = new Date();
    const lastDate = addDays(startDate, 9);
    return !(date >= startDate && date <= lastDate);
};

export const eMandateEndDateDisable = (date: Date, startDate: Date | string) => {
    return date > OTM_MAX_DATE(startDate); 
}
